import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import SEO from '../components/SEO';

const Legal = () => {
  const { language, t } = useLanguage();

  const seoData = {
    es: {
      title: 'Aviso Legal | PASTORIA SERRALTA, S.L.',
      description: 'Aviso legal de PASTORIA SERRALTA, S.L. Información sobre identificación, condiciones de uso, propiedad intelectual y legislación aplicable.'
    },
    en: {
      title: 'Legal Notice | PASTORIA SERRALTA, S.L.',
      description: 'Legal notice of PASTORIA SERRALTA, S.L. Information about identification, terms of use, intellectual property and applicable legislation.'
    }
  };

  return (
    <div className="min-h-screen bg-white" data-testid="legal-page">
      <SEO 
        title={seoData[language].title}
        description={seoData[language].description}
        url={language === 'es' ? '/aviso-legal' : '/en/legal'}
        noindex={false}
      />
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <h1 className="text-4xl sm:text-5xl font-bold text-[#363636] mb-8" data-testid="legal-title">
          {t.legal.title}
        </h1>
        <div 
          className="prose prose-lg max-w-none text-gray-700"
          dangerouslySetInnerHTML={{ __html: t.legal.content }}
          data-testid="legal-content"
        />
      </div>
    </div>
  );
};

export default Legal;